import { useAuth } from "../auth";
import { useTheme } from "../theme";
import { Icons } from "./icons";
import { OrgSelector } from "./OrgSelector";

interface Props {
  onMenuClick?: () => void;
}

export function Topbar({ onMenuClick }: Props = {}) {
  const { user, signOut } = useAuth();
  const { theme, toggle } = useTheme();

  const initial = (user?.email ?? "?").slice(0, 2).toUpperCase();

  return (
    <header className="topbar">
      <button
        type="button"
        className="btn btn-icon btn-ghost topbar-menu-toggle"
        aria-label="Abrir menú"
        onClick={onMenuClick}
      >
        <Icons.Menu size={16} sw={2} />
      </button>

      <div className="topbar-crumb">
        <OrgSelector />
        <EnvPill />
      </div>

      <div className="topbar-search">
        <Icons.Search size={14} />
        <span style={{ flex: 1 }}>Buscar por tags, correlationId, email…</span>
        <kbd>⌘ K</kbd>
      </div>

      <div className="topbar-actions">
        <span className="live-pill">
          <span className="live-dot" />
          <span className="live-pill-label">En vivo</span>
        </span>

        <button className="btn btn-icon btn-ghost" type="button" onClick={toggle} title={`Tema: ${theme}`}>
          {theme === "dark" ? <Icons.Sun size={15} /> : <Icons.Moon size={15} />}
        </button>

        <button className="btn btn-icon btn-ghost topbar-notif" type="button" title="Notificaciones">
          <Icons.Bell size={15} />
        </button>

        <button className="btn btn-icon btn-ghost" type="button" onClick={() => void signOut()} title="Cerrar sesión">
          <Icons.Logout size={15} />
        </button>

        <div className="avatar" title={user?.email ?? ""}>{initial}</div>
      </div>
    </header>
  );
}

/**
 * Pill de entorno: lee VITE_ENV / VITE_ENVIRONMENT (build-time) o cae
 * a dev cuando la app corre con Vite en modo desarrollo.
 *
 * - `dev`        → gris (neutro, no preocupa)
 * - `staging`    → naranja (cuidado, datos pre-prod)
 * - `prod` / `production` → rojo (estás en producción real)
 */
function EnvPill() {
  const raw =
    (import.meta.env.VITE_ENV as string | undefined) ??
    (import.meta.env.VITE_ENVIRONMENT as string | undefined) ??
    (import.meta.env.DEV ? "dev" : "prod");

  const env = raw.toLowerCase().trim();
  const display =
    env === "production" || env === "prod" ? "prod"
    : env === "staging" ? "staging"
    : env === "dev" || env === "development" ? "dev"
    : env;

  return <span className={`env-pill env-${display}`} title={`Entorno: ${display}`}>{display}</span>;
}
